import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ROLES = [["sugar_daddy", "Sugar Daddy"], ["sugar_mommy", "Sugar Mommy"], ["sugar_baby", "Sugar Baby"]];

export function RoleSelect({ value, onChange }) {
  return (
    <div>
      <p className="eyebrow mb-2">I am a</p>
      <div className="grid grid-cols-3 gap-2">
        {ROLES.map(([v, l]) => (
          <button type="button" key={v} data-testid={`role-option-${v}`} onClick={() => onChange(v)}
            className={`rounded border py-3 text-xs uppercase tracking-widest transition-colors ${value === v ? "border-red-600 bg-red-600/15 text-white" : "border-white/10 text-zinc-400 hover:border-white/30"}`}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export default function Onboarding() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ dob: user?.dob || "", role_type: user?.role_type || "sugar_baby", country: user?.country || "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/me", f);
      setUser(data);
      nav("/verify");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <main className="mx-auto max-w-md px-6 py-20">
      <p className="eyebrow mb-3">One last step</p>
      <h1 className="font-display mb-10 text-5xl">Complete your profile</h1>
      <form onSubmit={submit} className="space-y-5" data-testid="onboarding-form">
        <RoleSelect value={f.role_type} onChange={(v) => setF({ ...f, role_type: v })} />
        <Input data-testid="onboarding-dob-input" type="date" required value={f.dob} onChange={(e) => setF({ ...f, dob: e.target.value })} className="h-12 bg-zinc-900" />
        <Input data-testid="onboarding-country-input" placeholder="Country" value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} className="h-12 bg-zinc-900" />
        <p className="text-xs text-zinc-500">You must be 18 or older to use Diamond Luxury.</p>
        <button data-testid="onboarding-submit-btn" className="btn-red w-full rounded-full py-3 font-semibold">Continue</button>
      </form>
    </main>
  );
}
